<template>
<!--  -->
<Window :size="'m'" :bg="true" @Close="onClose" @Closed="onClosed" ref="Window">
	<div slot="head" class="w80pct-max textCut">{{activeIndex>=0?data[activeIndex].name:"--"}}</div>
	<button v-if="(!finalOutRole||finalOutRole.indexOf('A1')!=-1)&&doPermissions('A/B/A3',{targetCode:'A1',codeList:clone(roleCode)})" v-permissions="'A/B/A3'" permission-type="none" slot="headButton" class="fSub hover-f-primary" :title="$t('cmd8',['编辑'])" @click="edit" type="button">
		<Icon name="edit" class="w1x h1x" :sizeBase="'m'"/>
	</button>
 
	<button v-if="!finalOutRole||finalOutRole.indexOf('A1')!=-1" v-permissions="'A/B/A3'" permission-type="none" slot="headButton" class="fSub hover-f-error" :title="$t('cmd9',['删除'])" @click="remove" type="button">
		<Icon name="recycle" class="w1x h1x" :sizeBase="'m'"/>
	</button>
	<div class="ml1x mr1x mt1x" fillHeight="lastHeight" scroll>
		<div>
			<div v-if="activeIndex>=0" class="posR">
				<img :src="data[activeIndex].url" class="w100pct bgContent boxR-top dpB">
				<div class="ctrl ctrl-l boxR-top ofH tra-fast" :class="{disable:activeIndex<=0}">
					<button @click="flipPhoto(-1)" type="button"><Icon name="arrow-l" class="fWhite w2x h3x" /></button>
				</div>
				<div class="ctrl ctrl-r boxR-top ofH tra-fast" :class="{disable:activeIndex>=data.length-1}">
					<button @click="flipPhoto(1)" type="button"><Icon name="arrow-r" class="fWhite w2x h3x" /></button>
				</div>
			</div>
			<div v-if="activeIndex>=0" class="bgContent boxR-bottom pd1x lh15 mb1x">{{data[activeIndex].description}}</div>
		</div>
	</div>
</Window>
</template>
<script>
import * as lib from '@/util/lib';

import Window from '@/components/common/ui/WindowForView.vue';
import NewEdit from '@/components/common/viewPhoto/NewEdit.vue';
import Confirm from '@/components/common/ui/Confirm.vue';

import {apiDeletePhoto} from '@/api/maintain/plant/list';
export default{
	// name:"",
	components:{Window},
	props:{
     roleCode: {
      type: Array,
			default: () => {
      return []
      }
    },
		fromPart:{//运行于哪个版块
			type:String,
			default:""
		},
		addClass:{//激活的索引项
			type:[String,Object],
			default:""
		},
		finalOutRole:{//外部权限列表
			type:Array,
			default:null
		}
	},
	data(){
		return{
			dynamic:null,
			activeIndex:-1,//当前激活
			data:[],//数据集合
			needUpdateList:false//是否在关闭后触发更新外部列表
		}
	},
	watch:{},
	methods:{
    doPermissions:lib.doPermissions,
    clone (arr) {
			return _.cloneDeep(arr)
		},
		show:function(list,activeIndex,dynamic){
			if(dynamic) this.dynamic=dynamic;
			this.data=list;
			this.activeIndex=activeIndex;
			this.$refs.Window.loadStatusAction(true);
			this.$refs.Window.show({end:()=>{
				lib.fillHeight();
				this.$refs.Window.loadStatusAction(false);
				// lib.setScroll($(this.$el).find("[scroll]"));
			}});
		},
		onClose:function(){
			this.$emit("Close",this.needUpdateList);
		},
		onClosed:function(){
			if(this.dynamic) this.dynamic.destroyUi();
		},
		flipPhoto:function(next){
			if(this.activeIndex+next<this.data.length&&this.activeIndex+next>=0){//next>0&&
				this.activeIndex+=next;
			}
			// else if(){

			// }
		},
		edit:function(){
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").children(0)[0],NewEdit,
					{},
					{
						Update:[this.onUpdate.bind(this)],
					},{}
				).then(({instance, childInstance}) => {
					childInstance.show(this.data[this.activeIndex],instance);
				}
			);
		},
		remove:function(){//删除单个照片
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").children(0)[0],Confirm,
					{},
					{
						confirm:[()=>{
							this.$refs.Window.loadStatusAction(true);
							apiDeletePhoto(this.data[this.activeIndex].id).then(success=>{
								this.$refs.Window.hide();
								this.$emit("Delete",this.activeIndex);
								this.activeIndex=-1;
							},
							error=>{
								this.$refs.Window.loadStatusAction(false);
							});
						}],
					},{}
				).then(({instance, childInstance}) => {
					childInstance.show({text:getLanguageStr('plant_detail19','确认要删除该照片吗？')},instance);
				}
			);
		},
		onUpdate:function(data){//编辑成功后
			$.extend(this.data[this.activeIndex],data);
			this.$emit("Update",this.activeIndex);
		}
	},
	computed:{
	},
	created(){},
	mounted(){
		lib.fillHeight();
		this.$nextTick(()=>{
			lib.setScroll($(this.$el).find("[scroll]"));
		});
	},
	destroyed(){}
}
</script>
<style lang="scss" scoped>
.ctrl{height:100%;position:absolute;top:0;opacity:.6;
	&.disable{opacity:.1;}
	&:after{content:"";width:100%;height:100%;display:block;position:absolute;left:0;top:0;opacity:.6;}
	&:hover{opacity:1;}
	button{margin:{top:-1.5em;};padding:{left:1em;right:1em;};position:relative;top:50%;z-index:1;}
	&.ctrl-l{left:0;
		&:after{background-image:linear-gradient(90deg,rgba(#000,.4),rgba(#000,0));}
		&:hover:after{opacity:1;}
	}
	&.ctrl-r{right:0;
		&:after{background-image:linear-gradient(90deg,rgba(#000,0),rgba(#000,.4));}
		&:hover:after{opacity:1;}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/viewPhoto/Index.vue